module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/digital-realities-vr-ac-hotel.json
// module id = 421
// module chunks = 97137152394724